export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.project-center': 'Project Management',
  'menu.system': 'System Settings',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.system.permissions': 'Permission Management',
  'menu.system.dictionary': 'Data Dictionary',
  'menu.system.ai-model-binding': 'Model Binding',
  'menu.template-center': 'Template Center',
  'menu.template-center.detail': 'Template Detail',
  'menu.project-center.workbench': 'Workbench',
  'menu.project-center.project-overview': 'Project Overview',
  'menu.project-center.project-space': 'Project Space',
  'menu.project-center.my-tasks': 'My Tasks',
  'menu.project-center.my-projects': 'My Projects',
  'menu.project-center.dashboard': 'Problem Center',
  'menu.project-center.boards': 'Global Kanban',
  'menu.project-center.gantt': 'Global Gantt',
  'menu.project-center.projects': 'Project List',
  'menu.project-center.resources': 'Resource Center',
  'menu.project-center.calendar': 'Calendar',
  'menu.project-center.risks': 'Risk Center',
  'menu.project-center.analytics': 'Analytics',
  'menu.project-center.project-detail': 'Project Workspace',
  'menu.project-center.project-detail.overview': 'Project Overview',
  'menu.project-center.project-detail.kanban': 'Task Management',
  'menu.project-center.project-detail.gantt': 'Project Progress',
  'menu.project-center.project-detail.delivery': 'Documents',
  'menu.project-center.project-detail.acceptance': 'Acceptance',
  'menu.project-center.project-detail.communication': 'Communication',
  'menu.project-center.project-detail.members': 'Member Collaboration',
  'menu.project-center.project-detail.work-hours': 'Project Statistics',
  'menu.project-center.project-detail.issues': 'Risk Issues',
  'menu.project-center.project-detail.report': 'Project Reports',
  'menu.project-center.project-detail.review': 'Review',
  'menu.project-center.project-detail.activities': 'Project Activity',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
